module.exports = __webpack_public_path__ + "img/22.bee4bf49.png";